import {
  searchListings
} from "./chunk-MPUZIXB6.js";
import {
  findLocalityPlaceId
} from "./chunk-Z4OPEIBR.js";
import {
  mapOptionsToSearchListingsParams
} from "./chunk-POZ5IQ74.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getSimilarListingsPriceInfo,
  mapSearchListingsFiltersToSearchFilterRequest
} from "./chunk-J7WFOES5.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";
import {
  Currency,
  ListingSortOption,
  PropertyKind,
  PropertyMarketingType
} from "./chunk-VXLCCQ5A.js";

// src/services/getSimilarListings/getSimilarListings.ts
async function getSimilarListings(property, options, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getSimilarListings");
    const localityPlaceId = property.placeIds ? findLocalityPlaceId(property.placeIds) : void 0;
    if (!localityPlaceId) {
      throw new Error("The property does not have any locality place id");
    }
    const { businessArea, propertyMarketingType, isDevelopmentProject, hasPriceOnRequest, id } = property;
    const filters = {
      excludedPropertyIds: [id],
      businessArea: [businessArea],
      propertyMarketingType: [propertyMarketingType],
      placeIds: localityPlaceId ? [localityPlaceId] : [],
      sortingOptions: [
        propertyMarketingType === PropertyMarketingType.rent ? ListingSortOption.RENT_DESC : ListingSortOption.SALES_PRICE_DESC
      ]
    };
    const similarPropertiesPriceInfo = getSimilarListingsPriceInfo(property);
    if (isDevelopmentProject) {
      filters.propertyTypeSubType = { group: [] };
      filters.propertyKind = PropertyKind.group;
    } else {
      filters.propertyKind = PropertyKind.object;
      filters.searchRadius = 5;
      if (hasPriceOnRequest) {
        filters.priceOnRequest = true;
      } else if (similarPropertiesPriceInfo) {
        filters.price = similarPropertiesPriceInfo.rangeFilter;
      } else {
        return {
          status: "success",
          data: {
            listings: [],
            listingsTotal: 0,
            widerAreaListings: []
          }
        };
      }
    }
    const params = mapOptionsToSearchListingsParams(options);
    const data = await searchListings(
      mapSearchListingsFiltersToSearchFilterRequest(
        filters,
        { ...options, currency: property.baseCurrency ?? Currency.EUR },
        similarPropertiesPriceInfo?.priceType
      ),
      params,
      _apiConfig
    );
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getSimilarListings
};
